<template>
  <DecoratorState
    :hasTitleOnAdaptive="hasTitleOnAdaptive"
    title="Executing"
    :hasTitle="hasTitle"
    class="state-executing"
  >
    <template #icon>
      <IconMaterial title="play_arrow" size="16" class="state-executing__icon" />
    </template>
  </DecoratorState>
</template>

<script>
  import DecoratorState from '@/uikitProject/decorators/DecoratorState';
  import IconMaterial from '@/uikitBase/icons/IconMaterial';

  export default {
    name: 'StateExecuting',

    components: {
      IconMaterial,
      DecoratorState,
    },

    props: {
      hasTitle: {
        type: Boolean,
        default: true,
      },
      hasTitleOnAdaptive: {
        type: Boolean,
        default: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .state-executing {
    color: $color-text-process;
    font-weight: $weight-bold;

    &__icon {
      margin-right: -3px;
    }
  }
</style>
